import React, { forwardRef } from 'react'
import { Grid } from "@mui/material";
import Stack from '@mui/material/Stack';
import UiInput from '../../../_uiComponents/UiInput';
import UiSelect from '../../../_uiComponents/UiSelect';
import { UiButton } from '../../../../_uiComponents/common/form/UiButton';
import UiInnerSearchWr from '../../../../_uiComponents/common/UiInnerSearchWr';
import UiDateRangePicker from '../../../_uiComponents/UiDateRangePicker';


export default function NotificationTableFilterForm(props) {

    const [contains, setContains] = React.useState('');

    const handleContainChange = (event) => {
        setContains(event.target.value);
    };
    const options1 = [
        {value: 'value-1', label: 'One-time'},
        {value: 'value-2', label: 'Recurring'}
    ];

    const options2 = [
        {value: 'value-1', label: 'email'},
        {value: 'value-2', label: 'sms'},
        {value: 'value-2', label: 'In-system'}
    ];

    return (
        <>
            <UiInnerSearchWr>
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={9} >
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={4} className='sba-search-input' >
                                <UiInput type="text" label="Name" />
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <UiSelect label="Frequency"
                                    value={contains}
                                    handleChange={handleContainChange}
                                    options={options1} >
                                </UiSelect>
                            </Grid>
                            <Grid item xs={12} lg={4} className='sba-search-input' >
                                <UiSelect label="Channels"
                                    value={contains}
                                    handleChange={handleContainChange}
                                    options={options2} >
                                </UiSelect>
                            </Grid>
                            <Grid item xs={12} lg={4} >
                                <UiDateRangePicker />
                            </Grid>
                        </Grid>
                    </Grid>
                        <Grid item xs={12} lg={3} >
                            <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%',pt:0.6  }}>
                                <UiButton name="Clear" variant="outlined" size="small" />
                                <UiButton name="Apply" variant="contained" size="small" />
                            </Stack>
                        </Grid>
                   
                </Grid>
            </UiInnerSearchWr>

        </>
    )
}
